import { render, staticRenderFns } from "./CardAdicionarProdutoInsumos.vue?vue&type=template&id=0f3b9792&"
import script from "./CardAdicionarProdutoInsumos.vue?vue&type=script&lang=js&"
export * from "./CardAdicionarProdutoInsumos.vue?vue&type=script&lang=js&"
import style0 from "./CardAdicionarProdutoInsumos.vue?vue&type=style&index=0&id=0f3b9792&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports